import React from 'react';
import { CaptionText, HeadingText } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';

const GNSubheader = ({ organizationName, purpose }) => {
  return (
    <div className="donate_sub_header donate-main-content">
      <div className="gn-subheader">
        <CaptionText className="personal-fundraiser-header">
          {getContent('locals')('common/subHeader')(
            'label.donateToOrganization',
            { organization: organizationName },
            { useHTML: true }
          )}
        </CaptionText>
        <HeadingText className="gn-purpose" level={2}>
          {purpose}
        </HeadingText>
      </div>
    </div>
  );
};

GNSubheader.propTypes = {
  organizationName: PropTypes.string,
  purpose: PropTypes.string,
};

export default GNSubheader;
